/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Edit.scss'
import React from 'react'
import Toolbar from './Toolbar'
import Title from '../atoms/heading/Title'
import r from '../../util/Renderer'
import { OutlinedButton } from 'ui-library/dist/external/components'

function Edit(props) {
  const showButton = props.showButton !== undefined ? props.showButton : true
  const buttonLabel = props.buttonLabel || '作成'
  const buttonDisabled = props.buttonDisabled || false

  return (
    <div className="Edit">
      <Toolbar className="Toolbar">
        <div className="Toolbar--left">
          <button onClick={props.onCancel}>
            <svg width="15px" height="15px" viewBox="0 0 15 15">
              <g stroke="#A2A2A2" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M13.1993266,6.39488462e-14 L-1.15463195e-14,13.1993266" />
                <path d="M13.1993266,13.1993266 L1.77635684e-15,3.55271368e-15" />
              </g>
            </svg>
          </button>
        </div>
        <div className="Toolbar--center">
          <Title>{props.title}</Title>
        </div>
        <div className="Toolbar--right">
          {r.renderIf(showButton)(
            <OutlinedButton onClick={props.onSubmit} disabled={buttonDisabled}>
              {buttonLabel}
            </OutlinedButton>
          )}
        </div>
      </Toolbar>
      <div className="EditArea">{props.children}</div>
    </div>
  )
}

export default Edit
